module.exports = __webpack_public_path__ + "static/media/ic_mic_disabled.274c6f77.svg";